import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';

// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementContextualSurvey from '../../ui/contextual-survey';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementFlag from '../../ui/flag';
// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths
import EngagementModalDialog from '../../ui/modal-dialog';
// eslint-disable-next-line @repo/internal/react/no-class-components
var EngagementMessages = /*#__PURE__*/function (_Component) {
  _inherits(EngagementMessages, _Component);
  var _super = _createSuper(EngagementMessages);
  function EngagementMessages() {
    _classCallCheck(this, EngagementMessages);
    return _super.apply(this, arguments);
  }
  _createClass(EngagementMessages, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EngagementModalDialog, null), /*#__PURE__*/React.createElement(EngagementFlag, null), /*#__PURE__*/React.createElement(EngagementContextualSurvey, null));
    }
  }]);
  return EngagementMessages;
}(Component); // duplicate the export as a named one. That way, the export name in
// this entrypoint (defined in "af:exports") matches the name that is
// used in the main (src/index.ts) entrypoint.
export { EngagementMessages as default };
export { EngagementMessages };